import HelpIcon from "@mui/icons-material/Help";
import {
  FormControl,
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { NumericFormat } from "react-number-format";
import { _COLORS, _STATUTCOLORS } from "../../../utils/_constants";
import { _STYLES } from "../../../utils/_style_constants";
import { editInstantRequest } from "../../../utils/formHelper";
import _, { isUndefined } from "lodash";
import { createConfirm } from "../../../utils/confirm";
import MouseOverPopover from "../MouseOverPopover";
import { UserContext } from "../../contexts/UserContext";
import { useContext, useEffect, useState } from "react";

function CreationMandatVente({
  register,
  errors,
  typeVentes,
  currentMandat,
  setCurrentMandat,
  mode = "vente",
  refresh,
  disabledSign = false,
}) {
  const { user } = useContext(UserContext);
  const [canEditPartenaire, setCanEditPartenaire] = useState(false);

  useEffect(() => {
    if (user) {
      // Vérifie si l'utilisateur a le droit d'éditer le partenaire
      const agencesAuthorisees = (
        process.env.REACT_APP_aagencePartenaireNumber ?? ""
      )
        .split(",")
        .map((s) => s.trim());
      const agenceTraditionnelle = user.agencesList
        ? user.agencesList
            .split(",")
            .some((agence) => agencesAuthorisees.includes(agence.trim()))
        : false;
      setCanEditPartenaire(
        (user["profil"] === "SUSER" && agenceTraditionnelle) ||
          (user["profil"] === "USER" && agenceTraditionnelle) ||
          user["profil"] === "ADMIN" ||
          user["profil"] === "SADMIN",
      );
    }
  }, [user]);

  return (
    <>
      <Grid container spacing={1} padding={2}>
        {currentMandat.type !== "avenant" && (
          <>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  color: _COLORS.primary,
                  paddingBottom: 20,
                }}
              >
                Modification du mandat de {mode}
              </Typography>
            </Grid>
          </>
        )}

        {currentMandat.type !== "recherche" ? (
          <>
            <Grid item xs={12}>
              Statut : &nbsp;
              <strong>
                <span
                  style={{
                    color: currentMandat.statut
                      ? _STATUTCOLORS[currentMandat?.statut?.nomTechnique]
                      : "black",
                  }}
                >
                  {currentMandat.statut ? currentMandat?.statut?.nom : "N/A"}
                </span>
              </strong>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              alignItems={"center"}
              display={"flex"}
              gap={3}
            >
              <Grid item xs={4}>
                <Typography sx={{ ..._STYLES.typographyLabelTitle }}>
                  Type de vente*
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <FormControl sx={{ display: "flex" }} fullWidth>
                  <InputLabel id="typeVenteLabel" size="small">
                    Type de vente
                  </InputLabel>
                  <Select
                    label="Type de vente"
                    size="small"
                    disabled={currentMandat.type === "avenant" || disabledSign}
                    value={
                      currentMandat?.typeVente
                        ? currentMandat.typeVente["@id"]
                        : ""
                    }
                    {...register("typeVente", { required: false })}
                    id="typeVente"
                    onChange={(e) => {
                      if (!_.isNull(currentMandat?.typeVente)) {
                        createConfirm(
                          "Êtes-vous sûr de vouloir modifier le type de vente ? (Les ventilations de prix déjà existantes seronts supprimées)",
                        )
                          .fire({})
                          .then((result) => {
                            if (result.isConfirmed) {
                              // Traitement
                              let m = editInstantRequest(
                                e.target.value,
                                currentMandat["@id"],
                                "typeVente",
                              );

                              m.then((m) => {
                                setCurrentMandat(m);
                              });
                            } else {
                              // Annulation
                              setCurrentMandat(currentMandat);
                            }
                          });
                      } else {
                        let m = editInstantRequest(
                          e.target.value,
                          currentMandat["@id"],
                          "typeVente",
                        );

                        m.then((m) => {
                          setCurrentMandat(m);
                        });
                      }
                    }}
                  >
                    {typeVentes.map((typeVente, i) => (
                      <MenuItem key={i} value={typeVente["@id"]}>
                        {typeVente.nom}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.typeVente?.type === "required" && (
                    <Typography sx={_STYLES.errorMessage}>
                      Veuillez selectionner un type de vente
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </>
        ) : (
          <></>
        )}

        <Grid
          item
          xs={12}
          md={6}
          display={"flex"}
          gap={3}
          alignItems={"center"}
        >
          <Grid xs={4} item>
            <Typography
              variant="body1"
              sx={{ ..._STYLES.typographyLabelTitle }}
            >
              Exclusivité*
            </Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <FormControl fullWidth>
              <Select
                disabled={currentMandat.type === "avenant" || disabledSign}
                size="small"
                {...register("exclusif", { required: false })}
                id="exclusif"
                value={
                  !isUndefined(currentMandat?.exclusif)
                    ? currentMandat.exclusif
                    : ""
                }
                onChange={(e) => {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "exclusif",
                  );

                  m.then((m) => {
                    setCurrentMandat(m);
                  });
                }}
              >
                <MenuItem value=""></MenuItem>
                <MenuItem value={true}>Exclusif</MenuItem>
                <MenuItem value={false}>Non exclusif</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          alignItems={"center"}
          display={"flex"}
          gap={3}
        >
          <Grid item xs={4}>
            <Typography
              variant="body1"
              sx={{ ..._STYLES.typographyLabelTitle }}
            >
              Lieu de vente*
            </Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <FormControl fullWidth>
              <InputLabel size="small">Lieu de vente</InputLabel>
              <Select
                label="Lieu de la vente"
                size="small"
                disabled={currentMandat.type === "avenant" || disabledSign}
                {...register("lieuDeVente", { required: false })}
                id="lieuDeVente"
                value={
                  currentMandat?.lieuDeVente ? currentMandat.lieuDeVente : ""
                } // Utilisez la variable d'état pour définir la valeur sélectionnée
                onChange={(e) => {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "lieuDeVente",
                  );

                  m.then((m) => {
                    setCurrentMandat(m);
                  });
                  // Mettez à jour la variable d'état lorsqu'une nouvelle option est sélectionnée
                }}
              >
                <MenuItem key={1} value="horsEtablissement">
                  Hors établissement avec faculté de rétraction
                </MenuItem>
                <MenuItem key={2} value="auSeinEtablissement">
                  Au sein de l'établissement
                </MenuItem>
              </Select>
              {errors.lieuDeVente?.type === "required" && (
                <Typography sx={_STYLES.errorMessage}>
                  Veuillez selectionner un lieu de vente
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          display={"flex"}
          gap={3}
          alignItems={"center"}
        >
          {canEditPartenaire && (
            <>
              <Grid xs={2} md={1} item display={"flex"}>
                <Typography
                  variant="body1"
                  sx={{ ..._STYLES.typographyLabelTitle }}
                >
                  P
                </Typography>{" "}
                <MouseOverPopover
                  title={
                    <HelpIcon
                      sx={{ color: _COLORS.black, cursor: "pointer" }}
                    />
                  }
                  popoverText="Numéro Partenaire"
                />
              </Grid>
              <Grid item xs={2} md={1}>
                <FormControl fullWidth>
                  <NumericFormat
                    fullWidth
                    customInput={TextField}
                    size="small"
                    id={"partenaireNumber"}
                    label="Partenaire"
                    displayType="input"
                    disabled={currentMandat.type === "avenant" || disabledSign}
                    value={
                      currentMandat?.partenaireNumber !== null
                        ? currentMandat?.partenaireNumber
                        : ""
                    }
                    // Besoin de changer la valeur du state pour que le composant se rafraichisse
                    onBlur={(e) => {
                      let m = editInstantRequest(
                        e.target.value,
                        currentMandat["@id"],
                        "partenaireNumber",
                      );

                      m.then((m) => {
                        if (m["@context"] === "/api/contexts/Error") {
                          refresh();
                        } else {
                          setCurrentMandat(m);
                        }
                      });
                    }}
                  />
                </FormControl>
              </Grid>
            </>
          )}

          <Grid xs={canEditPartenaire ? 3 : 4} item display={"flex"}>
            <Typography
              variant="body1"
              sx={{ ..._STYLES.typographyLabelTitle }}
            >
              Numéro de Mandat*
            </Typography>
            <MouseOverPopover
              title={
                <HelpIcon sx={{ color: _COLORS.black, cursor: "pointer" }} />
              }
              popoverText="Veuillez indiquer uniquement votre dernier numéro de mandat. Votre numéro d'agence et le type de vente seront ajoutés automatiquement."
            />
          </Grid>
          <Grid item xs={6} md={canEditPartenaire ? 3 : 4}>
            <FormControl fullWidth>
              <NumericFormat
                fullWidth
                customInput={TextField}
                size="small"
                id={"numero"}
                label="Numéro de mandat"
                displayType="input"
                disabled={currentMandat.type === "avenant" || disabledSign}
                value={
                  currentMandat?.numero !== null ? currentMandat?.numero : ""
                }
                // Besoin de changer la valeur du state pour que le composant se rafraichisse
                onBlur={(e) => {
                  let m = editInstantRequest(
                    e.target.value,
                    currentMandat["@id"],
                    "numero",
                  );

                  m.then((m) => {
                    if (m["@context"] === "/api/contexts/Error") {
                      refresh();
                    } else {
                      setCurrentMandat(m);
                    }
                  });
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CreationMandatVente;
